import React from 'react'
import styles from './H1.module.scss'
import cl from 'classnames'
import { H1Props } from './H1.types'

const H1Component = (props: H1Props) => {
  const {
    className,
    children,
    bold,
    overflowEllipsis,
    ...rest
  } = props

  return (
    <h1
      className={cl(styles.heading1, {
        [styles.bold]: bold,
        [styles.textOverflow]: overflowEllipsis
      }, className)}
      {...rest}
    >
      {children}
    </h1>
  )
}

const H1 = H1Component
export { H1 }
